/* XGuidance commerce: "Added to cart" confirmation inside the side cart. */
(function () {
  'use strict';
  var pending = 0;
  function show(title) {
    var wrap = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper');
    if (!wrap) return;
    var old = wrap.querySelector('.xgc-added'); if (old) old.remove();
    var n = document.createElement('div');
    n.className = 'xgc-added'; n.setAttribute('role', 'status');
    n.innerHTML = '<i aria-hidden="true">✓</i><span></span>';
    n.querySelector('span').textContent = (title ? title + ' — ' : '') + 'added to your cart';
    wrap.insertBefore(n, wrap.firstChild);
    setTimeout(function () { n.classList.add('is-out'); setTimeout(function () { n.remove(); }, 400); }, 3200);
  }
  function added(body) {
    var title = '';
    try { var j = typeof body === 'string' ? JSON.parse(body) : body; title = (j && (j.product_title || (j.items && j.items[0] && j.items[0].product_title))) || ''; } catch (e) {}
    pending++;
    // the theme re-renders the drawer after adding; wait for it, then show the note
    var tries = 0, t = setInterval(function () {
      tries++;
      var open = document.body.classList.contains('cart-sidebar-show');
      if (open || tries > 25) { clearInterval(t); pending--; if (open) setTimeout(function () { show(title); }, 250); }
    }, 120);
  }
  var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); };
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = f.apply(this, arguments);
      if (isAdd(url)) p.then(function (r) { if (r && r.ok) r.clone().text().then(added).catch(function () { added(''); }); }).catch(function () {});
      return p;
    };
  }
  document.addEventListener('DOMContentLoaded', function () {
    if (window.jQuery) window.jQuery(document).ajaxSuccess(function (e, xhr, opts) { if (opts && isAdd(opts.url)) added(xhr && xhr.responseText); });
  });
})();
